export default "__VITE_ASSET__YrzApkob__"